import _ from 'underscore';
import { routerNameMapper } from './router-mapper';

const pathNamePrefix = '/campaign/vnext';

function getRoute(scope, siteMap, routeName, params) {
  const searchParams = _.isObject(params) ? _.omit(params, value => _.isUndefined(value)) : params;

  if (!_.has(routerNameMapper, routeName)) {
    console.warn(`route name (${routeName}) has not defined in new UI`); //eslint-disable-line
    return undefined;
  }

  const {
    route,
    search,
  } = routerNameMapper[routeName](scope, searchParams);

  return {
    pathname: route ? `${pathNamePrefix}/${route}` : pathNamePrefix,
    search,
  };
}

function navigateToRoute(scope, siteMap, routeName, params) {
  const route = getRoute(scope, siteMap, routeName, params);
  if (!route) {
    return false;
  }
  scope.history.push(route);
  return true;
}

function replaceToRoute(scope, siteMap, routeName, params) {
  const route = getRoute(scope, siteMap, routeName, params);
  if (!route) {
    return false;
  }
  scope.history.replace(route);
  return true;
}

function getRouteUrl(scope, siteMap, routeName, params) {
  const route = getRoute(scope, siteMap, routeName, params);
  if (!route) {
    return '';
  }
  return `${route.pathname}${route.search}`;
}

export function getRouterDep(scope, siteMap) {
  return {
    replaceToRoute: (routeName, params) => replaceToRoute(scope, siteMap, routeName, params),
    navigateToRoute: (routeName, params) => navigateToRoute(scope, siteMap, routeName, params),
    getRouteUrl: (routeName, params) => getRouteUrl(scope, siteMap, routeName, params),
  };
}
